import { Container, GridItem, Stack, Visibility } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@octopus-energy/coral/storyblok"
import { ConnectorMobile, FadeIn, GreenPot, Text } from "@/features/greenEnergy"
import {
    StyledAnimatedNumber,
    StyledEuros,
} from "@/features/greenEnergy/components/AnimatedNumber/AnimatedNumber.styled"
import { type SbBlokGreenEnergyInvest } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyInvest
}

export function DynamicEnergyInvest({ blok }: DynamicRenewableEnergyProps) {
    return (
        <GridItem
            gridRowStart={{ base: 9, xl: 6 }}
            gridColumnStart={{ base: 1, xl: 3 }}
            gridRowEnd={{ base: 10, xl: 7 }}
            gridColumnEnd={{ base: 3, xl: 6 }}
        >
            <FadeIn {...storyblokEditable(blok)}>
                <Container
                    position="relative"
                    zIndex={1}
                    marginBottom={{ base: "sm", xl: "none" }}
                    marginTop={{ xl: "md" }}
                >
                    <Stack
                        flexDirection="column"
                        gap="none"
                    >
                        <Stack
                            justifyContent="space-between"
                            alignItems="flex-end"
                        >
                            <Stack
                                flexDirection="column"
                                gap="none"
                            >
                                <Visibility hidden={{ base: false, xl: true }}>
                                    <FadeIn delay={1}>
                                        <ConnectorMobile size="xs" />
                                    </FadeIn>
                                </Visibility>
                                <Text>{blok.line1}</Text>
                                <Text>{blok.line2}</Text>
                            </Stack>
                            <GreenPot />
                        </Stack>

                        <Text showcased>
                            <StyledAnimatedNumber>{blok.amount}</StyledAnimatedNumber>
                        </Text>
                        <Text
                            showcased
                            textAlign={{ base: undefined, xl: "end" }}
                        >
                            <StyledEuros>{blok.currency}</StyledEuros>
                        </Text>

                        <Text textAlign={{ base: undefined, xl: "end" }}>{blok.line3}</Text>
                    </Stack>
                </Container>
            </FadeIn>
        </GridItem>
    )
}

export default DynamicEnergyInvest
